import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_g3nydf2am2: FaireBrandEntity = {
  token: "b_g3nydf2am2",
  type: "brand",
  name: "Faiza Naturals",
  avatarUrl:
    "https://cdn.faire.com/fastly/068bacddbc2249bc52dc9b0776aecb59f3144781e1423eb5329e9144daa1bc0d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/568a5eb7730b1887794a340661b559db3a2653fb7b2decf5979d01f375730765.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/068bacddbc2249bc52dc9b0776aecb59f3144781e1423eb5329e9144daa1bc0d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/568a5eb7730b1887794a340661b559db3a2653fb7b2decf5979d01f375730765.jpeg",
  location: "Upland, CA, USA",
  minimumOrderDollars: 50,
  rating: 4.8,
  reviewCount: 2582,
  isInsider: true,
  description:
    "We are an ethical natural and spiritual goods wholesale and distribution business that responsibly and sustainably acquires wholesome products. We have direct ownership in our all organic farm in Southern California allowing us to provide the highest quality with the best pricing on items such as hand-tied sage smudge sticks, abalone shell bowls, essential oils and so much more. Our focus is to produce lush and vibrant goods while maintaining sustainable farming practices such as sun-drying and rotational field harvesting in order to appease nature. All our merchandise are produced in small artisan batches and meticulously packaged. We always ship next day (except Sundays) so expect your orders to adorn your home and/or business within days! \n\nFor wholesale inquiries please message directly on Faire or email at:\n\n[redacted-email]",
  meta: {
    source: "api",
    importedAt: "2026-03-31T17:30:37.325Z",
    importedBy: "entity-db-cli",
  },
};
